import * as XLSX from 'xlsx'

const requiredHeaders = ['酒店编号', '上/下线', '对接酒店编号', '是否对接']

const text = value => String(value === null || value === undefined ? '' : value).trim()

export function parseJielvMatchedHotelWorkbook(data) {
  const workbook = XLSX.read(data, { type: 'array' })
  if (!workbook.SheetNames.length) throw new Error('Excel 中没有工作表')
  const sheet = workbook.Sheets[workbook.SheetNames[0]]
  const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false, defval: '' })
  if (!rows.length) throw new Error('Excel 内容为空')
  const headers = rows[0].map((value, index) => index === 0 ? text(value).replace(/^\uFEFF/, '') : text(value))
  const indexes = {}
  requiredHeaders.forEach(header => {
    const index = headers.indexOf(header)
    if (index < 0) throw new Error(`Excel 缺少“${header}”列`)
    indexes[header] = index
  })

  const unique = new Map()
  let skippedCount = 0
  let duplicateCount = 0
  rows.slice(1).forEach((row, offset) => {
    const sourceStatus = text(row[indexes['上/下线']])
    const matchStatus = text(row[indexes['是否对接']])
    const jielvHotelCode = text(row[indexes['酒店编号']])
    const hotelCode = text(row[indexes['对接酒店编号']])
    if (sourceStatus !== '上线' || matchStatus !== '生效') {
      skippedCount++
      return
    }
    if (!jielvHotelCode || !hotelCode) throw new Error(`第 ${offset + 2} 行的酒店编号或对接酒店编号为空`)
    const previous = unique.get(hotelCode)
    if (previous) {
      if (previous.jielv_hotel_code !== jielvHotelCode) throw new Error(`对接酒店编号 ${hotelCode} 对应多个捷旅酒店编号`)
      duplicateCount++
      return
    }
    unique.set(hotelCode, { jielv_hotel_code: jielvHotelCode, hotel_code: hotelCode })
  })
  const entries = Array.from(unique.values()).sort((left, right) => left.hotel_code.localeCompare(right.hotel_code))
  if (!entries.length) throw new Error('Excel 中没有“上线且生效”的匹配酒店')
  if (entries.length > 20000) throw new Error('单次最多导入 20000 家匹配酒店')
  return { entries, skippedCount, duplicateCount, sheetName: workbook.SheetNames[0] }
}
